export default __webpack_public_path__ + "media/images/images/carousel/08-934367f5bba1404eb683717cc1902192.jpg";